var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        id: "realNameDialog",
        title: _vm.title,
        visible: _vm.isShow,
        width: "620px",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
      },
      on: {
        close: _vm.closeDialog,
        "update:visible": function ($event) {
          _vm.isShow = $event
        },
      },
    },
    [
      _vm.active == "1"
        ? _c(
            "div",
            { attrs: { id: "realName" } },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "text-align": "left",
                    padding: "0px 0px 10px 0px",
                  },
                },
                [
                  _c(
                    "el-alert",
                    {
                      staticClass: "alert",
                      staticStyle: { padding: "8px" },
                      attrs: {
                        title: "",
                        type: "info",
                        "show-icon": "",
                        closable: false,
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "温馨提示：为了线上打款准确性，请填写支付宝账号对应的真实姓名"
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-form",
                {
                  ref: "form",
                  staticClass: "demo-ruleForm y-mt-30",
                  attrs: {
                    "label-width": "150px",
                    model: _vm.form,
                    rules: _vm.formRules,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "name-input",
                      attrs: { prop: "name", label: "支付宝真实姓名" },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入姓名", maxlength: 30 },
                        model: {
                          value: _vm.form.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "name", $$v)
                          },
                          expression: "form.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "form-btn", attrs: { "label-width": "0" } },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "y-w-100",
                          attrs: { type: "primary" },
                          on: { click: _vm.toVerifySucceeded },
                        },
                        [_vm._v("确认")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c("verify-succeeded", {
            attrs: { activeType: "showAccount", authCode: _vm.authCode },
            on: { close: _vm.closeDialog, toSetting: _vm.toSetting },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }